import React from 'react';

import PropTypes from 'prop-types';

import EletronicSign from '@/svg-icons/eletronic-sign';
import Type5Asec from '@/svg-icons/type-5asec';
import TypeAcompanhamentoObraSeazone from '@/svg-icons/type-acompanhamento-obra-seazone';
import TypeAcompanhamentoObraMM from '@/svg-icons/type-acompanhamentoObraMM';
import TypeAditivo from '@/svg-icons/type-aditivo';
import TypeAuditoriaLoja from '@/svg-icons/type-auditoriaLoja';
import TypeAuditoriaMM from '@/svg-icons/type-auditoriaLoja';
import TypeAvaliacao from '@/svg-icons/type-avaliacao';
import TypeAvaliacaoImobiliaria from '@/svg-icons/type-avaliacao-imobiliaria';
import TypeAvaliacaoHousi from '@/svg-icons/type-avaliacaoHousi';
import TypeAvaliacaoZap from '@/svg-icons/type-avaliacaoZap';
import TypeCacaVazamento from '@/svg-icons/type-caca-vazamento';
import TypeCautelar from '@/svg-icons/type-cautelar';
import TypeCautelarAterpa from '@/svg-icons/type-cautelarAterpa';
import TypeCautelarCCInfra from '@/svg-icons/type-cautelarCCInfra';
import TypeCautelarQueirozGalvao from '@/svg-icons/type-cautelarQueirozGalvao';
import TypeEntrega from '@/svg-icons/type-chaves';
import TypeEntregaHacasa from '@/svg-icons/type-chaves';
import TypeChecklistSamsung from '@/svg-icons/type-checklistSamsung';
import TypeConferencia from '@/svg-icons/type-conferencia';
import TypeConferenciaFinalDeObra from '@/svg-icons/type-conferenciaFinalDeObra';
import TypeCurtaTemporada from '@/svg-icons/type-curta-temporada';
import TypeEntrada from '@/svg-icons/type-entrada';
import TypeEntradaCurtaTemporada from '@/svg-icons/type-entrada-curta-temporada';
import TypeEntradaBHomy from '@/svg-icons/type-entradaBHomy';
import TypeEntradaLight from '@/svg-icons/type-entradaLight';
import TypeFichaCerta from '@/svg-icons/type-fichacerta';
import TypeFinalDeObra from '@/svg-icons/type-finalDeObra';
import TypeFotosDeCaptacao from '@/svg-icons/type-fotos-de-captacao';
import TypeIntermediariaBHomy from '@/svg-icons/type-intermediariaBHomy';
import TypeInventario from '@/svg-icons/type-inventario';
import TypeMedicaoObraTrinus from '@/svg-icons/type-medicao-obra-trinus';
import TypeNone from '@/svg-icons/type-none';
import TypePiloto from '@/svg-icons/type-piloto';
import TypePredial from '@/svg-icons/type-predial';
import TypePredialO2 from '@/svg-icons/type-predialO2';
import TypePreVistoriaBHomy from '@/svg-icons/type-preVistoriaBHomy';
import TypeSaida from '@/svg-icons/type-saida';
import TypeSaidaCurtaTemporada from '@/svg-icons/type-saida-curta-temporada';
import TypeSeguroLever from '@/svg-icons/type-seguro-lever';
import TypeTombamento from '@/svg-icons/type-tombamento';
import TypeTourVirtual from '@/svg-icons/type-tour-virtual';
import TypeTransferencia from '@/svg-icons/type-transferencia';
import TypeVisitaDigital from '@/svg-icons/type-visita-digital';
import TypeReparoFacil from '@/svg-icons/type-reparo-facil';

const firstDefaultViewBox = '0 0 34.016 34.016';
const secondDefaultViewBox = '0 0 69 70';

const orderTypeIconMapper = {
  conferencia: (fontSize, style) => (
    <TypeConferencia viewBox={firstDefaultViewBox} style={{ fontSize, ...style }} />
  ),
  VISTORIA_CONFERENCIA: (fontSize, style) => (
    <TypeConferencia viewBox={firstDefaultViewBox} style={{ fontSize, ...style }} />
  ),
  conferencia_legacy: (fontSize, style) => (
    <TypeConferencia viewBox={firstDefaultViewBox} style={{ fontSize, ...style }} />
  ),
  saida: (fontSize, style) => (
    <TypeSaida viewBox={firstDefaultViewBox} style={{ fontSize, ...style }} />
  ),
  VISTORIA_SAIDA: (fontSize, style) => (
    <TypeSaida viewBox={firstDefaultViewBox} style={{ fontSize, ...style }} />
  ),
  saida_legacy: (fontSize, style) => (
    <TypeSaida viewBox={firstDefaultViewBox} style={{ fontSize, ...style }} />
  ),
  entrada: (fontSize, style) => (
    <TypeEntrada viewBox={firstDefaultViewBox} style={{ fontSize, ...style }} />
  ),
  VISTORIA_ENTRADA: (fontSize, style) => (
    <TypeEntrada viewBox={firstDefaultViewBox} style={{ fontSize, ...style }} />
  ),
  constatacao: (fontSize, style) => (
    <TypeEntrada viewBox={firstDefaultViewBox} style={{ fontSize, ...style }} />
  ),
  VISTORIA_CONSTATACAO: (fontSize, style) => (
    <TypeEntrada viewBox={firstDefaultViewBox} style={{ fontSize, ...style }} />
  ),
  finalDeObra: (fontSize, style) => (
    <TypeFinalDeObra viewBox={secondDefaultViewBox} style={{ fontSize, ...style }} />
  ),
  VISTORIA_FINAL: (fontSize, style) => (
    <TypeFinalDeObra viewBox={secondDefaultViewBox} style={{ fontSize, ...style }} />
  ),
  VISTORIA_FINAL_DE_OBRA: (fontSize, style) => (
    <TypeFinalDeObra viewBox={secondDefaultViewBox} style={{ fontSize, ...style }} />
  ),
  finalDeObraBoticario: (fontSize, style) => (
    <TypeFinalDeObra viewBox={secondDefaultViewBox} style={{ fontSize, ...style }} />
  ),
  VISTORIA_FINAL_DE_OBRA_BOTICARIO: (fontSize, style) => (
    <TypeFinalDeObra viewBox={secondDefaultViewBox} style={{ fontSize, ...style }} />
  ),
  entrega: (fontSize, style) => (
    <TypeEntrega viewBox={firstDefaultViewBox} style={{ fontSize, ...style }} />
  ),
  VISTORIA_ENTREREGA: (fontSize, style) => (
    <TypeEntrega viewBox={firstDefaultViewBox} style={{ fontSize, ...style }} />
  ),
  entregaHacasa: (fontSize, style) => (
    <TypeEntregaHacasa viewBox={firstDefaultViewBox} style={{ fontSize, ...style }} />
  ),
  VISTORIA_ENTREGA_HACASA: (fontSize, style) => (
    <TypeEntregaHacasa viewBox={firstDefaultViewBox} style={{ fontSize, ...style }} />
  ),
  transferencia: (fontSize, style) => (
    <TypeTransferencia viewBox={firstDefaultViewBox} style={{ fontSize, ...style }} />
  ),
  VISTORIA_TRANSFERENCIA: (fontSize, style) => (
    <TypeTransferencia viewBox={firstDefaultViewBox} style={{ fontSize, ...style }} />
  ),
  predial: (fontSize, style) => (
    <TypePredial viewBox={firstDefaultViewBox} style={{ fontSize, ...style }} />
  ),
  VISTORIA_PREDIAL: (fontSize, style) => (
    <TypePredial viewBox={firstDefaultViewBox} style={{ fontSize, ...style }} />
  ),
  marketplace_docusign: (fontSize, style) => (
    <EletronicSign viewBox={firstDefaultViewBox} style={{ fontSize, ...style }} />
  ),
  VISTORIA_DOCUSIGN: (fontSize, style) => (
    <EletronicSign viewBox={firstDefaultViewBox} style={{ fontSize, ...style }} />
  ),
  marketplace_bry: (fontSize, style) => (
    <EletronicSign color="#00BCFF" viewBox={firstDefaultViewBox} style={{ fontSize, ...style }} />
  ),
  VISTORIA_BRY: (fontSize, style) => (
    <EletronicSign color="#00BCFF" viewBox={firstDefaultViewBox} style={{ fontSize, ...style }} />
  ),
  marketplace_captura360: (fontSize, style) => (
    <TypeVisitaDigital style={{ fontSize, ...style }} />
  ),
  VISTORIA_CAPTURA360: (fontSize, style) => (
    <TypeVisitaDigital style={{ fontSize, ...style }} />
  ),
  avaliacaoImobiliaria: (fontSize, style) => (
    <TypeAvaliacaoImobiliaria viewBox={firstDefaultViewBox} style={{ fontSize, ...style }} />
  ),
  VISTORIA_AVALIACAO_IMOBILIARIA: (fontSize, style) => (
    <TypeAvaliacaoImobiliaria viewBox={firstDefaultViewBox} style={{ fontSize, ...style }} />
  ),
  visitaDigital: (fontSize, style) => <TypeVisitaDigital style={{ fontSize, ...style }} />,
  VISTORIA_VISITA_DIGITAL: (fontSize, style) => <TypeVisitaDigital style={{ fontSize, ...style }} />,
  fotosDeCaptacao: (fontSize, style) => <TypeFotosDeCaptacao style={{ fontSize, ...style }} />,
  VISTORIA_FOTOS_DE_CAPTACAO: (fontSize, style) => <TypeFotosDeCaptacao style={{ fontSize, ...style }} />,
  seguroLever: (fontSize, style) => <TypeSeguroLever style={{ fontSize, ...style }} />,
  VISTORIA_SEGURO_LEVER: (fontSize, style) => <TypeSeguroLever style={{ fontSize, ...style }} />,
  tourVirtual: (fontSize, style) => (
    <TypeTourVirtual style={{ fontSize, padding: '2px', ...style }} />
  ),
  VISTORIA_TOUR_VIRTUAL: (fontSize, style) => (
    <TypeTourVirtual style={{ fontSize, padding: '2px', ...style }} />
  ),
  VISTORIA_5ASEC: (fontSize, style) => (
    <Type5Asec viewBox={secondDefaultViewBox} style={{ fontSize, ...style }} />
  ),
  '5asec': (fontSize, style) => (
    <Type5Asec viewBox={secondDefaultViewBox} style={{ fontSize, ...style }} />
  ),
  VISTORIA_ACOMPANHAMENTO_OBRA_MM: (fontSize, style) => (
    <TypeAcompanhamentoObraMM viewBox={secondDefaultViewBox} style={{ fontSize, ...style }} />
  ),
  acompanhamentoObraMM: (fontSize, style) => (
    <TypeAcompanhamentoObraMM viewBox={secondDefaultViewBox} style={{ fontSize, ...style }} />
  ),
  VISTORIA_ADITIVO: (fontSize, style) => (
    <TypeAditivo viewBox={secondDefaultViewBox} style={{ fontSize, ...style }} />
  ),
  aditivo: (fontSize, style) => (
    <TypeAditivo viewBox={secondDefaultViewBox} style={{ fontSize, ...style }} />
  ),
  VISTORIA_AUDITORIA_LOJA: (fontSize, style) => (
    <TypeAuditoriaLoja viewBox={secondDefaultViewBox} style={{ fontSize, ...style }} />
  ),
  auditoriaLoja: (fontSize, style) => (
    <TypeAuditoriaLoja viewBox={secondDefaultViewBox} style={{ fontSize, ...style }} />
  ),
  VISTORIA_AUDITORIA_VILA_TRAMPOLIM: (fontSize, style) => (
    <TypeAuditoriaLoja viewBox={secondDefaultViewBox} style={{ fontSize, ...style }} />
  ),
  auditoriaVilaTrampolim: (fontSize, style) => (
    <TypeAuditoriaLoja viewBox={secondDefaultViewBox} style={{ fontSize, ...style }} />
  ),
  VISTORIA_AUDITORIA_VAAPTY: (fontSize, style) => (
    <TypeAuditoriaLoja viewBox={secondDefaultViewBox} style={{ fontSize, ...style }} />
  ),
  auditoriaVaapty: (fontSize, style) => (
    <TypeAuditoriaLoja viewBox={secondDefaultViewBox} style={{ fontSize, ...style }} />
  ),
  fast4You: (fontSize, style) => (
    <TypeAuditoriaLoja viewBox={secondDefaultViewBox} style={{ fontSize, ...style }} />
  ),
  smartEsquadrias: (fontSize, style) => (
    <TypeAuditoriaLoja viewBox={secondDefaultViewBox} style={{ fontSize, ...style }} />
  ),
  levantamentoVivara: (fontSize, style) => (
    <TypeAuditoriaLoja viewBox={secondDefaultViewBox} style={{ fontSize, ...style }} />
  ),
  VISTORIA_AUDITORIA_ABC_CONSTRUCAO: (fontSize, style) => (
    <TypeAuditoriaLoja viewBox={secondDefaultViewBox} style={{ fontSize, ...style }} />
  ),
  auditoriaAbcConstrucao: (fontSize, style) => (
    <TypeAuditoriaLoja viewBox={secondDefaultViewBox} style={{ fontSize, ...style }} />
  ),
  VISTORIA_AUDITORIA_MM: (fontSize, style) => (
    <TypeAuditoriaMM viewBox={secondDefaultViewBox} style={{ fontSize, ...style }} />
  ),
  auditoriaMM: (fontSize, style) => (
    <TypeAuditoriaMM viewBox={secondDefaultViewBox} style={{ fontSize, ...style }} />
  ),
  VISTORIA_AVALIACAO: (fontSize, style) => (
    <TypeAvaliacao viewBox={secondDefaultViewBox} style={{ fontSize, ...style }} />
  ),
  avaliacao: (fontSize, style) => (
    <TypeAvaliacao viewBox={secondDefaultViewBox} style={{ fontSize, ...style }} />
  ),
  VISTORIA_HOUSI: (fontSize, style) => (
    <TypeAvaliacaoHousi viewBox={secondDefaultViewBox} style={{ fontSize, ...style }} />
  ),
  VISTORIA_AVALIACAO_HOUSI: (fontSize, style) => (
    <TypeAvaliacaoHousi viewBox={secondDefaultViewBox} style={{ fontSize, ...style }} />
  ),
  avaliacaoHousi: (fontSize, style) => (
    <TypeAvaliacaoHousi viewBox={secondDefaultViewBox} style={{ fontSize, ...style }} />
  ),
  VISTORIA_AVALIACAO_ZAP: (fontSize, style) => (
    <TypeAvaliacaoZap viewBox={secondDefaultViewBox} style={{ fontSize, ...style }} />
  ),
  avaliacaoZap: (fontSize, style) => (
    <TypeAvaliacaoZap viewBox={secondDefaultViewBox} style={{ fontSize, ...style }} />
  ),
  VISTORIA_CAUTELAR: (fontSize, style) => (
    <TypeCautelar viewBox={secondDefaultViewBox} style={{ fontSize, ...style }} />
  ),
  cautelar: (fontSize, style) => (
    <TypeCautelar viewBox={secondDefaultViewBox} style={{ fontSize, ...style }} />
  ),
  VISTORIA_CAUTELAR_ATERPA: (fontSize, style) => (
    <TypeCautelarAterpa viewBox={secondDefaultViewBox} style={{ fontSize, ...style }} />
  ),
  cautelarAterpa: (fontSize, style) => (
    <TypeCautelarAterpa viewBox={secondDefaultViewBox} style={{ fontSize, ...style }} />
  ),
  VISTORIA_CAUTELAR_CC_INFRA: (fontSize, style) => (
    <TypeCautelarCCInfra viewBox={secondDefaultViewBox} style={{ fontSize, ...style }} />
  ),
  cautelarCCInfra: (fontSize, style) => (
    <TypeCautelarCCInfra viewBox={secondDefaultViewBox} style={{ fontSize, ...style }} />
  ),
  VISTORIA_CAUTELAR_QUEIROZ_GALVAO: (fontSize, style) => (
    <TypeCautelarQueirozGalvao viewBox={secondDefaultViewBox} style={{ fontSize, ...style }} />
  ),
  cautelarQueirozGalvao: (fontSize, style) => (
    <TypeCautelarQueirozGalvao viewBox={secondDefaultViewBox} style={{ fontSize, ...style }} />
  ),
  VISTORIA_CHECKLIST_SAMSUNG: (fontSize, style) => (
    <TypeChecklistSamsung viewBox={secondDefaultViewBox} style={{ fontSize, ...style }} />
  ),
  checklistSamsung: (fontSize, style) => (
    <TypeChecklistSamsung viewBox={secondDefaultViewBox} style={{ fontSize, ...style }} />
  ),
  VISTORIA_CONFERENCIA_FINAL_DE_OBRA: (fontSize, style) => (
    <TypeConferenciaFinalDeObra viewBox={firstDefaultViewBox} style={{ fontSize, ...style }} />
  ),
  conferenciaFinalDeObra: (fontSize, style) => (
    <TypeConferenciaFinalDeObra viewBox={firstDefaultViewBox} style={{ fontSize, ...style }} />
  ),
  VISTORIA_CONFERENCIA_ENTREGA: (fontSize, style) => (
    <TypeEntrega viewBox={firstDefaultViewBox} style={{ fontSize, ...style }} />
  ),
  conferenciaEntrega: (fontSize, style) => (
    <TypeEntrega viewBox={firstDefaultViewBox} style={{ fontSize, ...style }} />
  ),
  VISTORIA_ENTRADA_B_HOMY: (fontSize, style) => (
    <TypeEntradaBHomy viewBox={firstDefaultViewBox} style={{ fontSize, ...style }} />
  ),
  entradaBHomy: (fontSize, style) => (
    <TypeEntradaBHomy viewBox={firstDefaultViewBox} style={{ fontSize, ...style }} />
  ),
  VISTORIA_ENTRADA_LIGHT: (fontSize, style) => (
    <TypeEntradaLight viewBox={firstDefaultViewBox} style={{ fontSize, ...style }} />
  ),
  entradaLight: (fontSize, style) => (
    <TypeEntradaLight viewBox={firstDefaultViewBox} style={{ fontSize, ...style }} />
  ),
  VISTORIA_INVENTARIO: (fontSize, style) => (
    <TypeInventario viewBox={secondDefaultViewBox} style={{ fontSize, ...style }} />
  ),
  inventario: (fontSize, style) => (
    <TypeInventario viewBox={secondDefaultViewBox} style={{ fontSize, ...style }} />
  ),
  VISTORIA_INVENTARIO_EQUIPAMENTOS_VTAL: (fontSize, style) => (
    <TypeInventario viewBox={secondDefaultViewBox} style={{ fontSize, ...style }} />
  ),
  inventarioEquipamentosVtal: (fontSize, style) => (
    <TypeInventario viewBox={secondDefaultViewBox} style={{ fontSize, ...style }} />
  ),
  inventarioElementosRede: (fontSize, style) => (
    <TypeInventario viewBox={secondDefaultViewBox} style={{ fontSize, ...style }} />
  ),
  VISTORIA_INVENTARIO_ELEMENTOS_REDE: (fontSize, style) => (
    <TypeInventario viewBox={secondDefaultViewBox} style={{ fontSize, ...style }} />
  ),
  VISTORIA_PILOTO: (fontSize, style) => (
    <TypePiloto viewBox={secondDefaultViewBox} style={{ fontSize, ...style }} />
  ),
  piloto: (fontSize, style) => <TypePiloto viewBox={secondDefaultViewBox} style={{ fontSize, ...style }} />,
  VISTORIA_PRE_VISTORIA_B_HOMY: (fontSize, style) => (
    <TypePreVistoriaBHomy viewBox={firstDefaultViewBox} style={{ fontSize, ...style }} />
  ),
  preVistoriaBHomy: (fontSize, style) => (
    <TypePreVistoriaBHomy viewBox={firstDefaultViewBox} style={{ fontSize, ...style }} />
  ),
  VISTORIA_PREDIAL_O2: (fontSize, style) => (
    <TypePredialO2 viewBox={firstDefaultViewBox} style={{ fontSize, ...style }} />
  ),
  predialO2: (fontSize, style) => <TypePredialO2 viewBox={firstDefaultViewBox} style={{ fontSize, ...style }} />,
  VISTORIA_TOMBAMENTO: (fontSize, style) => (
    <TypeTombamento viewBox={secondDefaultViewBox} style={{ fontSize, ...style }} />
  ),
  tombamento: (fontSize, style) => <TypeTombamento viewBox={secondDefaultViewBox} style={{ fontSize, ...style }} />,
  intermediariaBHomy: (fontSize, style) => (
    <TypeIntermediariaBHomy viewBox={secondDefaultViewBox} style={{ fontSize, ...style }} />
  ),
  VISTORIA_INTERMEDIARIA_B_HOMY: (fontSize, style) => (
    <TypeIntermediariaBHomy viewBox={secondDefaultViewBox} style={{ fontSize, ...style }} />
  ),
  VISTORIA_ENTRADA_CURTA_TEMPORADA: (fontSize, style) => (
    <TypeEntradaCurtaTemporada viewBox={firstDefaultViewBox} style={{ fontSize, ...style }} />
  ),
  entradaCurtaTemporada: (fontSize, style) => (
    <TypeEntradaCurtaTemporada viewBox={firstDefaultViewBox} style={{ fontSize, ...style }} />
  ),
  VISTORIA_CURTA_TEMPORADA: (fontSize, style) => (
    <TypeCurtaTemporada viewBox={firstDefaultViewBox} style={{ fontSize, ...style }} />
  ),
  curtaTemporada: (fontSize, style) => (
    <TypeCurtaTemporada viewBox={firstDefaultViewBox} style={{ fontSize, ...style }} />
  ),
  VISTORIA_SAIDA_CURTA_TEMPORADA: (fontSize, style) => (
    <TypeSaidaCurtaTemporada viewBox={firstDefaultViewBox} style={{ fontSize, ...style }} />
  ),
  saidaCurtaTemporada: (fontSize, style) => (
    <TypeSaidaCurtaTemporada viewBox={firstDefaultViewBox} style={{ fontSize, ...style }} />
  ),
  VISTORIA_ACOMPANHAMENTO_OBRA_SEAZONE: (fontSize, style) => (
    <TypeAcompanhamentoObraSeazone viewBox={firstDefaultViewBox} style={{ fontSize, ...style }} />
  ),
  acompanhamentoObraSeazone: (fontSize, style) => (
    <TypeAcompanhamentoObraSeazone viewBox={firstDefaultViewBox} style={{ fontSize, ...style }} />
  ),
  VISTORIA_MEDICAO_OBRA_TRINUS: (fontSize, style) => (
    <TypeMedicaoObraTrinus viewBox={firstDefaultViewBox} style={{ fontSize, ...style }} />
  ),
  medicaoObraTrinus: (fontSize, style) => (
    <TypeMedicaoObraTrinus viewBox={firstDefaultViewBox} style={{ fontSize, ...style }} />
  ),
  VISTORIA_FICHA_CERTA: (fontSize, style) => (
    <TypeFichaCerta viewBox={firstDefaultViewBox} style={{ fontSize, ...style }} />
  ),
  marketplace_fichacerta: (fontSize, style) => (
    <TypeFichaCerta viewBox={firstDefaultViewBox} style={{ fontSize, ...style }} />
  ),
  marketplace_reparofacil: (fontSize, style) => (
    <TypeReparoFacil viewBox={firstDefaultViewBox} style={{ fontSize, ...style }} />
  ),
  cacaVazamento: (fontSize, style) => (
    <TypeCacaVazamento viewBox={firstDefaultViewBox} style={{ fontSize, ...style }} />
  ),
  VISTORIA_CACA_VAZAMENTO: (fontSize, style) => (
    <TypeCacaVazamento viewBox={firstDefaultViewBox} style={{ fontSize, ...style }} />
  ),
  default: (fontSize, style) => <TypeNone viewBox={firstDefaultViewBox} style={{ fontSize, ...style }} />,
};

const OrderIcon = ({ fontSize, orderType }) => {
  const isSafeKey = typeof orderType === 'string' || typeof orderType === 'number';
  const iconKey = isSafeKey ? orderType : 'default';
  const iconFontSize = fontSize || '24px';

  const commonStyle = {
    verticalAlign: 'middle',
    marginRight: '10px',
    width: '1em',
    height: '1em',
    display: 'inline-block',
    flexShrink: 0,
  };

  const renderIcon = orderTypeIconMapper[iconKey] || orderTypeIconMapper.default;

  return renderIcon(iconFontSize, commonStyle);
};

OrderIcon.propTypes = {
  /**
   * String of the order type
   */
  orderType: PropTypes.string,
  /**
   * Size of the icon
   */
  fontSize: PropTypes.string,
};

export default OrderIcon;
